module.exports = __webpack_public_path__ + "static/media/your_domain.5a56240a.png";